export function safeDecodeURI(uri: string): string {
  try {
    return decodeURI(uri);
  } catch (e) {
    return uri;
  }
}
